__turbopack_context__.v({
  "filterChip": "FilterChip-module-scss-module__YInKGa__filterChip",
});
